import axios from 'axios';

class RoleApi {
    constructor() {
        this.endpoint =  process.env.VUE_APP_BASE_API;
    }
    list(isActivated) {
        return axios.get(`${this.endpoint}/role/list/${isActivated??''}`, {}).then(response=>response.data);
    }
    saveRole(role) {
        // console.log(role);
        return axios.post(`${this.endpoint}/role/save`, role).then(response=>response.data);
    }
    deleteRole(roleId) {
        return axios.delete(`${this.endpoint}/role/delete/${roleId}`, {}).then(response=>response.data);
    }
    mappingEndpoints(roleId, endpoints) {
        return axios.post(`${this.endpoint}/role/${roleId}/mapping/endpoints`, endpoints).then(() => {});
    }
    getEndpoints(roleId) {
        return axios.get(`${this.endpoint}/role/${roleId}/endpoints`, {}).then(response=>response.data);
    }
    mappingMenus(roleId, menus) {
        return axios.post(`${this.endpoint}/role/${roleId}/mapping/menus`, menus).then(() => {});
    }
    getMenus(roleId) {
        return axios.get(`${this.endpoint}/role/${roleId}/menus`, {}).then(response=>response.data);
    }

}

export default new RoleApi();
